export const HomeText = "百亿数据织就文学西湖，贯通古今纵览诗文地理：10000+诗文、1000+作家、200+地标";